import { SpecialHoursInputEntry } from 'common/components/weekly-schedules';

export const hasOverlappingTimePairs = (entry: SpecialHoursInputEntry) => {
  for (let i = 0; i < entry.timePairs.length; i++) {
    for (let j = i + 1; j < entry.timePairs.length; j++) {
      const { startMinutes: startA, endMinutes: endA } = entry.timePairs[i];
      const { startMinutes: startB, endMinutes: endB } = entry.timePairs[j];
      if (startA < endB && startB < endA) {
        return true;
      }
    }
  }
  return false;
};
